var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M9.79053 4.04297C10.7257 4.06535 11.6559 4.43354 12.3751 5.14813C13.1001 5.8689 13.4789 6.81088 13.5095 7.76198",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M9.79053 2.0144C11.2357 2.05464 12.67 2.62952 13.781 3.74081C14.8909 4.8515 15.4772 6.29712 15.5381 7.76197",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M15.5377 15.5381L12.1567 13.5095",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    d: "M4.01218 5.47356L1.87053 2.25546C1.73032 2.38133 1.64255 2.46358 1.64255 2.46358C0.838141 3.18077 1.01693 3.80777 1.01693 3.80777C1.56037 7.64136 5.59272 11.3346 5.90081 11.6562C6.31701 12.0427 9.91873 15.9963 13.7499 16.5354C13.7499 16.5354 14.3764 16.714 15.0924 15.9075L15.3151 15.6623C15.5908 15.2982 16.5366 14.0737 16.5454 13.8688C16.5454 13.8688 16.635 13.4668 16.1643 13.131L13.3446 11.2518C13.3446 11.2518 12.8521 10.804 12.1588 11.1852L10.4586 12.1264C10.4586 12.1264 8.75321 10.7719 7.80771 9.74578C6.78151 8.80102 5.42571 7.09572 5.42571 7.09572L6.36472 5.39367C6.7444 4.69947 6.29698 4.20719 6.29698 4.20719L4.41541 1.38705C4.07992 0.917465 3.67728 1.00678 3.67728 1.00678C3.46962 1.01622 3.09791 1.25558 2.72854 1.53797",
    stroke: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1c87c11be0b0958923ccb563596521c2.svg";
export { ForwardRef as ReactComponent };